import { render, staticRenderFns } from "./ReportingPortfolio.vue?vue&type=template&id=41689780&scoped=true&"
import script from "./ReportingPortfolio.vue?vue&type=script&lang=js&"
export * from "./ReportingPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./ReportingPortfolio.vue?vue&type=style&index=0&id=41689780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41689780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VProgressCircular,VRow})
